const KeenSlider = window.KeenSlider

const { setInitialised, useArrows } = window.BAO.Carousel.plugins

class SplitCollectionCarousel extends window.BAO.CustomElement() {
  connectedCallback () {
    super.connectedCallback()

    if (!this.els?.slides?.exists || !this.els?.slide?.exists) return

    this.carousel = this.setupCarousel()
  }

  disconnectedCallback () {
    super.disconnectedCallback()
    this.carousel?.destroy()
  }

  setupCarousel () {
    return new KeenSlider(
      this.els.slides.element,
      {
        selector: this.els.slide.selector,
        loop: false,
        mode: 'snap',
        slides: {
          perView: 1.8,
          spacing: 30,
          origin: 'center',
        },
      },
      [
        setInitialised(),
        useArrows({
          next: this.els?.next?.element,
          previous: this.els?.previous?.element,
        }),
      ],
    )
  }
}

if (!customElements.get('split-collection-carousel')) {
  customElements.define('split-collection-carousel', SplitCollectionCarousel)
}
